import React from 'react';
import './GeneralDocs.css'; 

const Introduction = () => {
  return (
    <div className="docs-page-container">
      <h1>What is FaceLead?</h1>
      <p>
        FaceLead is an app meant to control your computer using only your face. It does so by detecting the inputs that you give via camera.
      </p>
      <p> FaceLead currently supports 2 detectors: a Face Gestures detector and a Blink detector. Face Gestures detector will be used in
         the examples of the following sections. To see specific Blinks detector documentation, go <a href="/docs/blinks">here</a>.
      </p>

      <h2>How FaceLead Manages the Inputs That You Give?</h2>
      <ul>
        <li>
          Every input (gesture or blink) will represent a number. For example, you can create a gesture where you move your mouth to the left
          (call it gesture 1), and a gesture where you move your mouth to the right (call it gesture 2).
        </li>
        <li>
          You can associate a gesture or combination of gestures to an Instruction. For example, moving your mouth two times to the left
           can be associated with a mouse double left click.
        </li>
        <li>
          You can wrap a set of instructions into a Mode. For example, you can have a Mode for mouse Instructions, where doing gesture 1 twice is associated 
          to a double left click, and a Mode for keyboard Instructions, where doing gesture 1 twice is associated to the letter "a".
        </li>
      </ul>

      <p>In the <a href="/docs/modes">next section</a>, you will learn how modes work.</p>
    </div>
  );
};

export default Introduction;
